var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-progress-circular',{class:_vm.pulseClass,attrs:{"size":80,"value":(_vm.time / _vm.time_seconds) * 100,"width":7,"color":_vm.baseColor}},[_vm._v(" "+_vm._s(_vm.format_minutes_to_hours_minutes(_vm.time))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }